import {axiosApiCallWithToken} from "../axios/customInstance";

export const getChatbotInteractions = async () => {
    const url = "/chatbotInteractions";

    try {
        return await axiosApiCallWithToken.get(url);
    } catch (error) {
        console.log(error);
        return error.response;
    }
};

export const getChatbotInteractionsPerDate = async (startDate, EndDate) => {
    const url = "/chatbotInteractionsPerDate?startDate=" + startDate + "&endDate=" + EndDate;

    try {
        return await axiosApiCallWithToken.get(url);
    } catch (error) {
        console.log(error);
        return error.response;
    }
};


export const getBloodPressureMeasurements = async () => {
    const url = "/pressureMeasurements";

    try {
        return await axiosApiCallWithToken.get(url);
    } catch (error) {
        console.log(error);
        return error.response;
    }
};


export const getBloodPressureMeasurementsPerDate = async (startDate, EndDate) => {
    const url = "/pressureMeasurementsPerDate?startDate=" + startDate + "&endDate=" + EndDate;


    return await axiosApiCallWithToken.get(url);

};

export const getBloodPressureNotifications = async () => {
    const url = "/pressureNotifications";

    try {
        return await axiosApiCallWithToken.get(url);
    } catch (error) {
        console.log(error);
        return error.response;
    }
};

export const getBloodPressureNotificationsPerUser = async (userId) => {
    const url = "/pressureNotifications/user?userId=" + userId;

    try {
        return await axiosApiCallWithToken.get(url);
    } catch (error) {
        console.log(error);
        return error.response;
    }
};


export const getBloodPressureMeasurementsPerUser = async (userId) => {
    const url = "/pressureMeasurements/user?userId=" + userId;

    try {
        return await axiosApiCallWithToken.get(url);
    } catch (error) {
        console.log(error);
        return error.response;
    }
};


export const getTotalIntakeLogs = async () => {
  const url = "/intake_logs";

  try {
    return await axiosApiCallWithToken.get(url);
  } catch (error) {
    console.log(error);
    return error.response;
  }
};


export const getDrugAssumptionNotifications = async () => {
  const url = "/getDrugAssumptionNotifications";

  try {
    return await axiosApiCallWithToken.get(url);
  } catch (error) {
    console.log(error);
    return error.response;
  }
};


export const getEducationalNotifications = async () => {
  const url = "/getEducationalNotifications";

  try {
    return await axiosApiCallWithToken.get(url);
  } catch (error) {
    console.log(error);
    return error.response;
  }
};
